/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BadgeList = {
    type: 'array',
    contains: {
        type: 'Badge',
    },
} as const;
